import axios from "axios";

const CURRENT_APP_VERSION = "current_app_version";

export default {
  getLatestAppVersion() {
    return axios.get(process.env.VUE_APP_API_URL + "version")
      .then(({ data }) => data['latest_version']);
  },

  getCurrentAppVersion() {
    return localStorage.getItem(CURRENT_APP_VERSION);
  },

  setCurrentAppVersion(version) {
    localStorage.setItem(CURRENT_APP_VERSION, version);
  }
}